import React from 'react';
import { withStyles } from '@material-ui/core';
import { LabeledToggle } from '../../../../../../common/MUI';
import { weekdaysShortName } from './Constants';

const styles = (theme) => ({
  container: {
    marginTop: 14,
    marginBottom:14
  },
  headerText: {
    marginBottom: 8,
    color: theme.chatMetadataColor,
    fontSize: theme.fontSize,
    fontWeight: 500,
    lineHeight: 'normal'
  },
  toggleContainer: {
    maxWidth: '70%'
  }
});

const DayOfWeekStatus = ({ classes, dowOpen, onChange }) => {
  const onToggleValueChange = (checked, meta) => {
    const newDowOpen = dowOpen;
    newDowOpen[meta.index] = { name: meta.dow.name, value: checked };
    onChange(newDowOpen);
  };

  return (
    <div className={classes.container}>
      <div className={classes.headerText}> DAY OF WEEK STATUS</div>
      {dowOpen.map((dow, index) => (
        <LabeledToggle
          key={dow.name}
          label={dow.name}
          checked={dow.value}
          meta={{ dow, index }}
          onChange={onToggleValueChange}
          labelFormatter={(label) => `${label} (${weekdaysShortName[label.toLowerCase()]})`}
          classes={{
            container: classes.toggleContainer
          }}
        />
      ))}
    </div>
  );
};
export default withStyles(styles)(DayOfWeekStatus);
